import { createSlice } from '@reduxjs/toolkit';

import type { TripHistoryState } from './tripHistorySlice.model';
import { TRIP_HISTORY_REDUCERS } from './tripHistorySlice.reducers';

const initialState: TripHistoryState = {
  selectedDate: undefined,
  selectedTripId: null,
  hoveredTripId: null,
  selectedClusterId: null,
  selectedEventId: null,
  hoveredEventId: null,
  assetId: null,
  isMapReady: false,
  clusterCoordinates: null,
  hoverOnList: false,
  hoverEventType: null,
};

export const tripHistorySlice = createSlice({
  name: 'tripHistory',
  initialState,
  reducers: {
    selectTrip: TRIP_HISTORY_REDUCERS.selectTrip,
    hoverTrip: TRIP_HISTORY_REDUCERS.hoverTrip,
    selectCluster: TRIP_HISTORY_REDUCERS.selectCluster,
    selectDate: TRIP_HISTORY_REDUCERS.selectDate,
    selectEvent: TRIP_HISTORY_REDUCERS.selectEvent,
    hoverEvent: TRIP_HISTORY_REDUCERS.hoverEvent,
    setAssetId: TRIP_HISTORY_REDUCERS.setAssetId,
    setMapReady: TRIP_HISTORY_REDUCERS.setMapReady,
    setClusterCoordinates: TRIP_HISTORY_REDUCERS.setClusterCoordinates,
    setHoverOnList: TRIP_HISTORY_REDUCERS.setHoverOnList,
    setHoverEventType: TRIP_HISTORY_REDUCERS.setHoverEventType,
  },
});

export const {
  selectTrip,
  hoverTrip,
  selectCluster,
  selectDate,
  selectEvent,
  hoverEvent,
  setAssetId,
  setMapReady,
  setClusterCoordinates,
  setHoverOnList,
  setHoverEventType,
} = tripHistorySlice.actions;

export const tripHistoryReducer = tripHistorySlice.reducer;

export * from './tripHistorySlice.selectors';
